import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "1px solid #0000001A",
  borderRadius: "16px",
  boxShadow: 24,
  p: 4,
};

export default function SuccessModal({ open, handleClose, msg, nav }) {
  const navigate = useNavigate();
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <span
              style={{
                background: "#E5E5E5",
                borderRadius: "50%",
                padding: "4px",
                display: "flex",
                alignItems: "center",
              }}
              onClick={handleClose}
            >
              <ClearIcon />
            </span>
          </div>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {msg}
          </Typography>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {nav ?
            <Button className="btn-contained" onClick={() => navigate(nav)}>
              Okay
            </Button> :
            <Button className="btn-contained" onClick={handleClose}>
            Okay
          </Button>}
          </div>
        </Box>
      </Modal>
    </div>
  );
}
